module.exports = __webpack_public_path__ + "img/section3Card2BrandIcon6.e80fe7f5.png";